import { render, staticRenderFns } from "./StoryStatisticTipsList.vue?vue&type=template&id=4ebd918b&scoped=true&"
import script from "./StoryStatisticTipsList.vue?vue&type=script&lang=ts&"
export * from "./StoryStatisticTipsList.vue?vue&type=script&lang=ts&"
import style0 from "./StoryStatisticTipsList.vue?vue&type=style&index=0&id=4ebd918b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd918b",
  null
  
)

export default component.exports